import { setToken, removeToken } from '@/utils/auth';

export const logoutMixin = {
  methods:{
    // 退出登录
    logout(){
      removeToken();
      setToken('');
      this.$store.commit('USER_INFO', {});
      if(location.pathname === '/information' ||
      location.pathname.indexOf('/products') > -1 ||
      location.pathname.indexOf('/authentication') > -1 ||
      location.pathname.indexOf('/settings') > -1 ||
      location.pathname.indexOf('/management') > -1
      ){
        location.href = '/';
      }else if(location.pathname.indexOf('/deleteAccount') > -1){
        return
      }else{
        location.href = location.href;
      }
    }
  }
}
